import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";

const Podcast = () => {
  const soundCloudUrl = "https://soundcloud.com/marathonruns"; // Direct link to your SoundCloud profile

  return (
    <Container maxWidth="md" sx={{ textAlign: 'center', py: 8 }}>
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
        Listen to the MRuns Podcast
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
        Our podcast episodes are hosted on SoundCloud. Click the button below to listen to all our episodes and subscribe!
      </Typography>
      <Box>
        <Button
          variant="contained"
          color="primary"
          href={soundCloudUrl}
          target="_blank"
          rel="noopener noreferrer"
          size="large"
        >
          Listen on SoundCloud
        </Button>
      </Box>
    </Container>
  );
};

export default Podcast;
